import { api } from '../api';

const getTicketCarProviderLogs = async ({
  pageNumber = 1,
  pageSize = 10,
  customerId = null,
  filter = null,
}) => {
  const data = {
    page: pageNumber,
    pageSize,
    customerId,
    filter,
  };
  const response = await api({
    url: `Vehicles/GetTicketCarProviderLogs`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data,
    params: null,
  });
  return response.data;
};

const updateTicketCarProviderLogs = async (ids) => {
  const data = {
    ids,
  };
  const response = await api({
    url: `Vehicles/UpdateTicketCarProviderLogs`,
    method: 'POST',
    headers: {
      'x-skip-loader': true,
    },
    data,
    params: null,
  });
  return response.data;
};

const errorListServices = {
  getTicketCarProviderLogs,
  updateTicketCarProviderLogs,
};

export default errorListServices;
